module.exports = __webpack_public_path__ + "img/img-introduce@2x.b42d546f.png";